








import { Vue, Component } from 'vue-property-decorator';
import BasicSetting from '@/views/professionalWork/workflow/basicSettings/unit/basicSetting.vue';

@Component({
  components: {
    BasicSetting,
  },
})
export default class BasicIndex extends Vue {}
